<template>
    <div class="modal fade" :class="{ show: isVisible }" :style="{ display: isVisible ? 'block' : 'none' }"
        tabindex="-1" aria-labelledby="supportFeesModalLabel2" aria-modal="true" role="dialog">
        <div class="modal-dialog ms-auto">
            <div class="modal-content" style="background: #111c44;">
                <div class="modal-header" style="border-bottom:none">
                    <h6 class="modal-title" id="supportFeesModalLabel"> </h6>
                    <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <!-- État initial - Confirmation -->
                    <div class="modal-body text-center pt-4 pb-4"
                        v-if="alert_text && !hasPendingClaim && !hasApprovedClaim && !hasInProgressClaim">
                        <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
                        <h6> {{ $t("fees_modal.title1") }} </h6>
                        <p class="px-6">{{ $t("fees_modal.content1") }}</p>
                    </div>

                    <!-- État en attente -->
                    <div class="modal-body text-center pt-4 pb-4" v-if="hasPendingClaim">
                        <i class="bi bi-hourglass-split text-warning fs-2 mb-3"></i>
                        <h6>{{ $t("fees_modal.claim_status_pending") }}</h6>
                       

                    </div>

                    <!-- État approuvé -->
                    <div class="modal-body text-center pt-4 pb-4" v-if="hasApprovedClaim">
                        <div class="modal-body text-center pt-4 pb-4" v-if="bear_costs === api_config.BEAR_COSTS">
                            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
                            <h6> {{ $t("fees_modal.title2") }} </h6>
                            <p class="px-6">{{ $t("fees_modal.content2") }}</p>

                        </div>

                        <div class="modal-body text-center pt-4 pb-4" v-else>
                            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
                            <h6> {{ $t("fees_modal.title1") }} </h6>
                            <p class="px-6">{{ $t("fees_modal.content1") }}</p>

                        </div>

                    </div>

                    <!-- État en cours -->
                    <div class="modal-body text-center pt-4 pb-4" v-if="hasInProgressClaim">
                        <i class="bi bi-arrow-repeat text-info fs-2 mb-3"></i>
                        <h6>{{ $t("fees_modal.in_progress_title") }}</h6>
                     

                    </div>
                </div>

                <div class="modal-footer mb-1 pb-5" style="border-top:none">
                   
                    <template
                        v-if="(alert_text && !hasPendingClaim && !hasApprovedClaim && !hasInProgressClaim) || hasApprovedClaim">
                        <argon-button type="button" class="btn bg-transparent" @click="closeModal"
                            style="width: 150px; height: 50px; padding-top: 15px ;border:1px solid rgba(255, 255, 255, 0.4);">
                            {{ $t("button.cancel") }}
                        </argon-button>
                        <template v-if="bear_costs">
                        <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="success"
                            variant="gradient" type="button" class="mt-1"
                            style="width: 150px; height: 50px; padding-top: 15px; margin-right: 11px;" @click="Fees_payments1"
                            v-if="bear_costs === api_config.BEAR_COSTS">
                            <span v-if="!loading">{{ $t("button.confirm") }}</span>
                        </argon-button>
                        <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="success"
                            variant="gradient" type="button" class="mt-1"
                            style="width: 150px; height: 50px; padding-top: 15px; margin-right: 11px;" @click="Fees_payments" v-else>
                            <span v-if="!loading">{{ $t("button.confirm") }}</span>
                        </argon-button>
                    </template>
                    <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="success"
                            variant="gradient" type="button" class="mt-1"
                            style="width: 150px; height: 50px; padding-top: 15px;margin-right: 11px;" @click="Fees_payments" v-else>
                            <span v-if="!loading">{{ $t("button.confirm") }}</span>
                        </argon-button>
                    </template>

                    <!-- Bouton pour les autres états -->
                    <argon-button v-else type="button" class="btn bg-transparent" @click="closeModal"
                        style="width: 150px; height: 50px; padding-top: 15px ;border:1px solid rgba(255, 255, 255, 0.4); margin-right: 110px;">
                        {{ $t("button.close") }}
                    </argon-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api_config from "@/config";
import ArgonButton from "@/components/ArgonButton";
import { submit_claims_active_fees_payment, getCleams } from "@/utils/services";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
    name: 'SupportFeesModal',
    data() {
        return {
            loading: false,
            buttonActive: false,
            showConfirmation: false,
            xpay_connection_id: localStorage.getItem('xpay_connection_id'),
            name: localStorage.getItem('name'),
            alert_text: true,
            message_success: false,
            showValidation: false,
            Fees_on_payer: api_config.FEES_ON_PAYER,
            claims: [],
            bear_costs: null,
            api_config
        }
    },
    props: ['isVisible'],
    components: {
        ArgonButton
    },
    computed: {
        hasPendingClaim() {
            return this.claims && this.claims.data &&
                this.claims.data.some(claim => claim.status === 0);
        },

        hasInProgressClaim() {
            return this.claims && this.claims.data &&
                this.claims.data.some(claim => claim.status === 1);
        },

        hasApprovedClaim() {
            return this.claims && this.claims.data &&
                this.claims.data.some(claim => claim.status === 2);
        }
    },
    methods: {

        getPendingClaimValue() {
            if (!this.claims || !this.claims.data) return false;
            const pendingClaim = this.claims.data.find(claim => claim.status === 0);
            return pendingClaim?.data?.bear_costs ?? false;
        },

        getApprovedClaimValue() {
            if (!this.claims || !this.claims.data) return false;
            const approvedClaim = this.claims.data.find(claim => claim.status === 2);
            return approvedClaim?.data?.bear_costs ?? false;
        },

        getInProgressClaimValue() {
            if (!this.claims || !this.claims.data) return false;
            const inProgressClaim = this.claims.data.find(claim => claim.status === 1);
            return inProgressClaim?.data?.bear_costs ?? false;
        },
        hideModal() {
            this.$emit('update:isVisible', false);
        },
        closeModal() {
            this.$emit('update:isVisible', false);
            this.$emit('close');
            this.alert_text = true
        },

        async Fees_payments() {

            if (this.loading) return;

            try {
                this.loading = true;
                this.buttonActive = true;

                const response = await submit_claims_active_fees_payment(
                    'appConfig',
                    api_config.FEES_ON_PAYER_TITLE,
                    this.name,
                    this.xpay_connection_id,
                    api_config.BEAR_COSTS,
                );

                if (response) {

                    const message = this.$t("fees_modal.success_title");
                    toast.success(message, {
                        autoClose: 3000,
                    });

                    setTimeout(() => {
                        window.location.reload();
                        this.transfer_min_amount = this.selectedAmount;

                    }, 3000);

                }
            } catch (error) {
                console.error('Erreur lors de la soumission de la réclamation:', error);

            } finally {
                this.loading = false;
                this.buttonActive = false;
            }
        },

        async Fees_payments1() {

            if (this.loading) return;

            try {
                this.loading = true;
                this.buttonActive = true;

                const response = await submit_claims_active_fees_payment(
                    'appConfig',
                    api_config.FEES_ON_PAYER_TITLE,
                    this.name,
                    this.xpay_connection_id,
                    api_config.NO_BEAR_COSTS,
                );

                if (response) {

                    const message = this.$t("fees_modal.success_title");
                    toast.success(message, {
                        autoClose: 3000,
                    });

                    setTimeout(() => {
                        window.location.reload();
                        this.transfer_min_amount = this.selectedAmount;

                    }, 3000);

                }
            } catch (error) {
                console.error('Erreur lors de la soumission de la réclamation:', error);

            } finally {
                this.loading = false;
                this.buttonActive = false;
            }
        },

        async fetchgetclaimsbearcosts() {
            const connection_id = this.xpay_connection_id;
            const type = "AppConfig";
            const title = api_config.FEES_ON_PAYER_TITLE;

            try {
                let response = await getCleams(connection_id, type, title);
                this.claims = response || [];
                this.bear_costs = this.claims.data.map(claim => claim.data.bear_costs);
            } catch (error) {
                console.error("Error fetching incorrect amount claims:", error);
            } finally {
                this.loading = false;
            }
        },


    },
    mounted() {
        this.fetchgetclaimsbearcosts();
    },

};
</script>

<style scoped>
.modal.show {
    display: block;
}
</style>